import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { InferRequestType, InferResponseType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type DeleteDocumentsRequest = InferRequestType<
  (typeof apiClient.documents)['$delete']
>['json']
type DeleteDocumentsResponse = InferResponseType<
  (typeof apiClient.documents)['$delete']
>

export const useDeleteDocuments = (
  options?: UseMutationOptions<
    DeleteDocumentsResponse,
    Error,
    DeleteDocumentsRequest
  >
) =>
  useMutation({
    mutationFn: async (variables) => {
      return await apiClient.documents
        .$delete({ json: variables })

        .then((r) => formatClientResponse(r))
    },
    mutationKey: ['documents-delete'],
    ...options,
  })
